import { render, staticRenderFns } from "./edituserdata.vue?vue&type=template&id=0a91e505&"
import script from "./edituserdata.vue?vue&type=script&lang=js&"
export * from "./edituserdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports